import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga4';
import { Box, Typography, RadioGroup, FormControlLabel, Radio, TextField } from '@mui/material';
import BaseModal from 'components/BaseModal';
import { CartAbandonmentReasonEnum } from 'enums';
import { useAuthUser } from 'features/auth/AuthUserContext';

const Props = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onActionClick: PropTypes.func.isRequired,
};

export default function CartAbandonmentModalChina({ open, onClose, onActionClick }) {
  const [reason, setReason] = useState('');
  const [description, setDescription] = useState('');
  const { user } = useAuthUser();

  function sendTrackingEvents() {
    ReactGA.event({
      category: 'checkout',
      action: 'cart_abandonment_china',
      label: 'When user click in "Share with us" button',
      value: user.id,
    });
  }

  function handleActionClick() {
    sendTrackingEvents();

    onActionClick({ reason, description });

    setReason('');
    setDescription('');
  }

  return (
    <BaseModal
      size="sm"
      open={open}
      title={<b>请您留步</b>}
      content={
        <Box px={2}>
          <Typography>您是否愿意告诉我们您离开的原因？</Typography>

          <Box display="flex" justifyContent="center" my={4}>
            <RadioGroup value={reason} onChange={({ target: { value } }) => setReason(value)}>
              <FormControlLabel
                label="我有付款方面的问题"
                value={CartAbandonmentReasonEnum.PAYMENT_ISSUE}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="我暂时不想订阅"
                value={CartAbandonmentReasonEnum.NOT_READY}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="订阅方案选择有误"
                value={CartAbandonmentReasonEnum.WRONG_PLAN}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="服务价格不理想"
                value={CartAbandonmentReasonEnum.TOO_EXPENSIVE}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="其他原因"
                value={CartAbandonmentReasonEnum.OTHER}
                control={<Radio color="secondary" />}
              />
            </RadioGroup>
          </Box>

          {reason === CartAbandonmentReasonEnum.OTHER && (
            <TextField
              fullWidth={true}
              multiline={true}
              variant="outlined"
              inputProps={{ minRows: 2 }}
              label="请告诉我们更多有关问题的信息"
              value={description}
              onChange={({ target: { value } }) => setDescription(value)}
            />
          )}
        </Box>
      }
      actionText="与我们分享"
      disableActionButton={!reason}
      cancelButton={false}
      onActionClick={handleActionClick}
      onClose={onClose}
    />
  );
}

CartAbandonmentModalChina.propTypes = Props;
